module.exports = __webpack_public_path__ + "img/xiaochengxu2.9ab2f228.png";